import { useEffect, useRef, useState } from 'react';

/**
 * Custom hook for IntersectionObserver to detect when an element enters viewport
 * @param {Object} options - Options for IntersectionObserver
 * @param {number} options.threshold - Visibility threshold (default: 0.2)
 * @returns {Object} { sectionRef, isVisible }
 */
function useIntersectionObserver(options = { threshold: 0.2 }) {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      options
    );

    const currentRef = sectionRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [options]);

  return { sectionRef, isVisible };
}

export default useIntersectionObserver;
